var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17317 5.6959C4.99611 5.89062 4.75609 6 4.50584 6C4.25559 6 4.01557 5.89062 3.8385 5.6959L0.276457 1.77507C0.0993852 1.58 -5.91853e-05 1.31547 -4.54453e-08 1.03967C5.90944e-05 0.763865 0.099617 0.499385 0.276772 0.30441C0.453926 0.109434 0.694166 -6.53358e-05 0.944642 -3.23188e-07C1.19512 6.46894e-05 1.43531 0.109689 1.61238 0.304756L4.50584 3.49078L7.39929 0.304757C7.57732 0.11525 7.81581 0.0103159 8.06342 0.0125556C8.31102 0.0147954 8.54792 0.124029 8.72309 0.316731C8.89827 0.509433 8.99769 0.770184 8.99996 1.04282C9.00223 1.31546 8.90715 1.57817 8.73522 1.77438L5.1738 5.69659L5.17317 5.6959Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/down-arrow-icon.aefd08199ab52cf9624146133a0e60ed.svg";
export { ForwardRef as ReactComponent };